import {Store} from '@effector/effector'
import {h, data, list} from '../h'
import {generateValueHighlight} from './generateHighlight'
import {remap} from '../storeField'

export function HighlightValue(value: Store<any>) {
  const highlighted = value.map(generateValueHighlight)
  Highlight(highlighted)
}
export function Highlight(tokens: Store<any[]>) {
  h('pre', () => {
    data({codeHighlight: true})
    list(tokens, ({store}) => {
      const [type, value] = remap(store, ['type', 'value'] as const)
      h('span', {
        data: {codeType: type},
        text: value
      })
    })
  })
}
